import checkIcon from 'assets/icons/check.svg';
import { Fragment } from 'react/jsx-runtime';
import { useStoreSelector } from 'v3/data/store';
import {
  setCancelationErrorModalOpen,
  setCurrentCancellationState,
} from 'v3/data/store/cancellationNavigation/actions';
import { CancellationNavigationEnum } from 'v3/data/store/cancellationNavigation/enum';
import { cancellationSteps, REQUEST_CANCELLATION_INDEX } from 'v3/pages/OnlineContracting/Cancellation/constants';
import { AlignButtons, AlignIcon, Content, TitleSection } from 'v3/pages/OnlineContracting/Cancellation/styles';
import * as onlineApi from 'v3/services/online/api';
import { CancellationActionEnum } from 'v3/services/online/interfaces/types';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { TextButton } from 'v3/shared/components/Button/TextButton';
import { HorizontalStepper } from 'v3/shared/components/HorizontalStepper';
import { HeadlineSmall } from 'v3/shared/typography/HeadlineSmall';
import { SubtitleMedium } from 'v3/shared/typography/SubtitleMedium';
import { theme } from 'v3/styles/global-styles';

export const RequestAcceptedStep = () => {
  const { contractingKey, paymentDetails } = useStoreSelector((store) => store.onlineContracting);
  const { storeUserId } = useStoreSelector((store) => store.store.storeLogged);

  const handleRefuseCancellation = async () => {
    try {
      await onlineApi.refuseCancellation(contractingKey, {
        vtexPaymentId: paymentDetails.paymentId,
        vtexOrderId: paymentDetails.orderId,
        reason: 'Recusa do cancelamento feita pelo Backoffice',
        storeUserId: storeUserId,
        action: CancellationActionEnum.REFUSE_CANCELLATION,
      });
      setCurrentCancellationState(CancellationNavigationEnum.CANCELLATION_REFUSED);
    } catch (error) {
      console.error('Error requesting cancellation:', error);
      setCancelationErrorModalOpen(true);
    }
  };

  const handleConfirmCancellation = () => {
    setCurrentCancellationState(CancellationNavigationEnum.CANCELLATION_ACCEPTED);
  };

  return (
    <Fragment>
      <HorizontalStepper completedStepIndex={REQUEST_CANCELLATION_INDEX} steps={cancellationSteps} />

      <Content>
        <AlignIcon>
          <img src={checkIcon} alt="Success" />
        </AlignIcon>
        <TitleSection>
          <HeadlineSmall color={theme.palette.info.main}>Sua solicitação foi aceita!</HeadlineSmall>
          <SubtitleMedium color={theme.palette.secondary.light}>
            Os pagamentos foram congelados, para concluir o processo você precisa confirmar o cancelamento
          </SubtitleMedium>
        </TitleSection>
        <AlignButtons>
          <TextButton text="Cancelar solicitação" $outline size="small" handleClick={handleRefuseCancellation} />
          <FlexButton text="Confirmar o cancelamento" size="small" handleClick={handleConfirmCancellation} />
        </AlignButtons>
      </Content>
    </Fragment>
  );
};
